import React from 'react';

function FormatStyles() {
    return (
        <div>
            <h1> Format Styles Placeholder</h1>
            LITEr is under development. Check back later for more updates!
        </div>
    )
}

export default FormatStyles;